import React from "react";
import { FaReact } from "react-icons/fa";
import { IoLogoNodejs } from "react-icons/io";
import { DiMongodb } from "react-icons/di";
import { MdLocalPostOffice } from "react-icons/md";
import { SiRedux, SiFirebase } from "react-icons/si";
import { BsBootstrapFill } from "react-icons/bs";

const Technologies = () => {
  return (
    <div id="technologies" className="technologies-wraper">
      <h1 className="tech-header">Technologies</h1>
      <div className="tech_boxes">
        <div className="single_box">
          <div className="skill_card frontend_box">
            <div className="layer1"></div>
            <div className="content">
              <div className="skill_name">
                <span>React Js</span>
                <span>Redux</span>
                <span>Bootstrap</span>
              </div>

              <div class="image1">
                <FaReact className="skill_logo react" />
                <SiRedux className="skill_logo redux" />
                <BsBootstrapFill className="skill_logo boot" />
              </div>
              <div class="details">
                <h2>
                  <span>FRONTEND</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className=" single_box">
          <div className="skill_card db_box">
            <div className="layer2"></div>
            <div className="content">
              <div className="skill_name">
                <span>Mongo DB</span>
                <span>Fire Base</span>
              </div>

              <div class="image2">
                <DiMongodb className="skill_logo mongo" />
                <SiFirebase className="skill_logo fire" />
              </div>
              <div class="details">
                <h2>
                  <span>DATA BASE</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div className="single_box">
          <div className="skill_card backend_box">
            <div className="layer3"></div>
            <div className="content">
              <div className="skill_name">
                <span>Node.js</span>
                <span>Express.js</span>
              </div>
              <div class="image3">
                <IoLogoNodejs className="skill_logo node" />
                <MdLocalPostOffice className="skill_logo express" />
              </div>
              <div class="details">
                <h2>
                  <span>BACKEND</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technologies;
